import Modal from '../scripts/modal'
import carriersSelect from '../scripts/get-carriers-select'
import ContactForm from '../views/contact-form'
import merge from 'lodash.merge';

class AddContactModal {

  constructor (settings = {}) {

    this.settings = merge({
      onSuccess: null,
    }, settings);

    this.modal = new Modal({
      title: 'Create Contact',
    });

    this.modal.setContent(`
    <form class="contact-form create-contact">

      <div class="contact-form__content">

        <div class="setting">
          <div class="setting__label">Name</div>
          <input type="text" name="contact_name" placeholder="A name or description for this contact" required />
        </div>
        <div class="setting">
          <div class="setting__label">Invitation Email</div>
          <input type="email" name="email" />
          <div class="setting__description">An invitation to receive alerts will be sent to this email</div>
        </div>

      </div>

      <div class="setting-save">
        <div class="setting-save__button">
          <button type="submit" class="button button--blue">Create Contact</button>
        </div>
        <div class="setting-save__message"></div>
      </div>

    </form>
    `);

    this.form = this.modal.getContainer().querySelector('form');

    this.contactForm = new ContactForm({
      form: this.form,
      onSubmit: data => {

        this.contactForm.disableForm();
        this.contactForm.showFormMessage('Saving...');

        window.apiRequest('post', '/contacts/create', data).then(r => {

          if(r.type === 'error') {

            this.contactForm.showFormMessage(r.message, true);

          } else {

            window.PubSub.publish('contacts/updated');

            if(this.settings.onSuccess !== null) {
              this.settings.onSuccess(r);
            }

            this.modal.close();

          }

        });

      },
    });

  }

  init() {

    this.modal.open();

  }

}

export default AddContactModal;
